/** Shared button labels for delete confirmation modals. */
export const STANDARD_DELETE_CONFIRM_OK_TEXT = 'OK';
export const STANDARD_DELETE_CONFIRM_CANCEL_TEXT = 'キャンセル';

/** Default modal title (spec). */
export const STANDARD_DELETE_CONFIRM_TITLE = '削除確認';

/** Default body line (spec): full-width quotes + ？ */
export const STANDARD_DELETE_CONFIRM_MESSAGE = '本当に削除してもよろしいですか？';
